import { MonthEnum, UID } from './types';

export enum BillingAccountEnum {
  'licensing' = 'licensing',
  'rebilling' = 'rebilling',
}

export enum BillingStatus {
  'paused' = 'paused',
  'running' = 'running',
}

export enum BillingDiscountType {
  'cost' = 'cost',
  'percent' = 'percent',
}

export type BillingOrganisation = {
  status: BillingStatus;
  invoicePrefix: string;
  invoicePaymentTermsDays: number;
  assessmentInvoiceMonths: MonthEnum[];
  hasFreeAssessments: boolean;
};

export type BillingProduct = {
  id: UID;
  name: string;
  cost: number;
  vat: number;
  account: BillingAccountEnum;
  invoiceCode: string;
  invoiceToOrganisationId: UID | null;
  months: MonthEnum[];
};

export type BillingProductUnits = {
  productId: UID;
  units: number;
};

export type BillingItem = {
  id: UID;
  name: string;
  cost: number;
  vat: number;
  account: BillingAccountEnum;
  invoiceCode: string;
  invoiceToOrganisationId: UID | null;
  months: MonthEnum[];
  repeating: boolean;
};

export type BillingDiscount = {
  id: UID;
  name: string;
  type: BillingDiscountType;
  cost: number;
  remainingCost: number;
  percent: number;
  invoiceCodes: string;
  expiryDate: number;
};
